module.exports = __webpack_public_path__ + "img/wheel_buyfeature_normal_fg.f7b0c35f.png";